module.exports = __webpack_public_path__ + "img/cartoonHead3-1.ddb90c15.png";